 $(document).ready(function () {
  
  $(".bf_nav_item").click(function (e) {
    const mq = window.matchMedia("(min-width: 993px)"),
        ele = $(this);
    if (!mq.matches) {
       e.preventDefault();
        $(".dropdown").not(ele.find('.dropdown')).slideUp(500);
        ele.find('.dropdown').slideToggle(500);
        $(".bf_nav_item").not(ele).removeClass('active');
        ele.toggleClass('active');
    }
  });
  $(".bf_navbar_toggle").click(function (e) {
    e.preventDefault();
    $(".bf_nav_menu").addClass('active');
    $('body').addClass('overflow_hidden');
  });

  $(".bf_overlay, .bf_close_icon_nav").click(function (e) {
    e.preventDefault();
    $(".bf_nav_menu").removeClass('active');
    $('body').removeClass('overflow_hidden');
  });

  $('.variant-swatch').click(function(){
    
    const images = JSON.parse($(this).attr('var-images'));
    const videos = JSON.parse($(this).attr('var-videos'));

    if( images.length != 0 || videos != null) {
      var html = '<div class="main-slider">';
        $.each(images, function(key,val){
          if(key >= 0){
            html += '<div class="main-item"><img src="'+val+'"></div>';
          }
        });
        $.each(videos, function(key,val){
          if(key >= 0){
            html += '<div class="main-item"><video width="'+val.sources[0].width+'" height="'+val.sources[0].height+'" controls autoplay muted loop><source src="'+val.sources[0].url+'" type="video/mp4"></video></div>';
          }
        });
      html += '</div>';
      
      html += '<div class="nav-slider-for">';
       $.each(images, function(key,val){
        if(key >= 0){
          var filer_img = val.replace(".jpg", "_100x.jpg");
          html += '<div class="nav-slider-for-item"><img src="'+filer_img+'"></div>';
        }
      });
      $.each(videos, function(key,val){
        if(key >= 0){
          html += '<div class="nav-slider-for-item"><img src="'+val.preview_image.src+'"></div>';
        }
      });
      html += '</div>';
      $('.variant-slider-box').show();
      $('.bf_product_slider').addClass('variant_slider');
      $('.bf_product_slider').find('.product__media.became-visible').hide();
      $('.variant-slider-box').html(html);

      var options_main = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:'<button class="left-arr hidden-lap-and-up tap-area tap-area--large"><svg class="PwzrSvgIcon-root PwzrSvgIcon-fontSizeLarge" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path></svg></button>',
        nextArrow:'<button class="right-arr hidden-lap-and-up tap-area tap-area--large"><svg class="PwzrSvgIcon-root PwzrSvgIcon-fontSizeLarge" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path></svg><button>',
        asNavFor: '.nav-slider-for',
        arrows : false
      }

      var options_for = {
        infinite: false,
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow:'<button class="left-arr hidden-lap-and-up tap-area tap-area--large"><svg class="PwzrSvgIcon-root PwzrSvgIcon-fontSizeLarge" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path></svg></button>',
        nextArrow:'<button class="right-arr hidden-lap-and-up tap-area tap-area--large"><svg class="PwzrSvgIcon-root PwzrSvgIcon-fontSizeLarge" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path></svg></button>',
        asNavFor: '.main-slider',
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
              vertical: false,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          }
        ]
      }

      $('.main-slider').slick(options_main);
      $('.nav-slider-for').slick(options_for);


      // Reinitializing the slider due to client's Mac issue
      setTimeout(function() {
        $('.nav-slider-for').slick('unslick');
        $('.nav-slider-for').slick(options_for);
      }, 1000);
      setTimeout(function() {
        $('.nav-slider-for').slick('unslick');
        $('.nav-slider-for').slick(options_for);
      }, 1500);
      
    } else {
      $('.bf_product_slider').find('.product__media.became-visible').show();
      $('.variant-slider-box').hide();
    }
  });

  $('button.bf_quick_view.bf_main_btn').click(function(){
    var test = $(this).attr('aria-expanded');
    console.log(test);
    if (test == 'true') {
      $('header.bf_header-bf_header').hide();
    }
  });
   
});

